let productImages = null
let waitForVariantInputsAttempts = 0

const knownShapes = [
    "round",
    "cushion",
    "oval",
    "heart",
    "princess",
    "pear",
    "marquise",
    "emerald",
    "asscher",
    "radiant",
    "old mine",
    "oldmine"
]

const zoomIconSvg = '<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M12.375 4.0625H15.9375V7.625" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M11.7812 8.21875L15.9375 4.0625" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M7.625 15.9375H4.0625V12.375" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/><path d="M8.21875 11.7812L4.0625 15.9375" stroke="var(--color-body)" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'

function withShopifyImageWidth(url, width) {

    if (!url) {
        return url
    }

    if (/[?&]width=\d+/i.test(url)) {
        return url.replace(/([?&]width=)\d+/i, `$1${width}`)
    }

    return `${url}${url.includes("?") ? "&" : "?"}width=${width}`
}

function getProductImages() {
        console.log('getProductImages()',productImages);

    if (!productImages) {

        let jsonEl = document.getElementById("ProductVariantImages")
        if(!jsonEl){
            jsonEl = document.getElementById("ProductVariantImagesQuick");
        }

        if (!jsonEl) {
            console.error("ProductVariantImages JSON not found")
            return []
        }

        productImages = JSON.parse(jsonEl.textContent)

    }

    return productImages
}


function normalizeText(value) {

    return (value || "")
        .toLowerCase()
        .replace(/[_/]+/g, " ")
        .replace(/\s+/g, " ")
        .trim()
}


function detectMetal(value) {

    const text = normalizeText(value)

    if (!text) {
        return ""
    }

    if (text.includes("black")) return "black gold"
    if (text.includes("platinum") || /\bplt\b/.test(text)) return "platinum"
    if (text.includes("white")) return "white gold"
    if (text.includes("yellow")) return "yellow gold"
    if (text.includes("rose")) return "rose gold"

    return ""
}


function getVariantSelectElement() {

    return document.querySelector('variant-selects:not([data-sticky="1"])') || document.querySelector("variant-selects")
}


function getVariantData() {

    const variantSelect = getVariantSelectElement()

    if (!variantSelect) {
        return []
    }

    if (!variantSelect.variantImageFilterData) {
        const jsonEl = variantSelect.querySelector('script[type="application/json"]')
        variantSelect.variantImageFilterData = jsonEl ? JSON.parse(jsonEl.textContent) : []
    }

    return variantSelect.variantImageFilterData || []
}


function getCurrentVariant() {

    const variantSelect = getVariantSelectElement()
    const variantData = getVariantData()

    if (!variantSelect || !variantData.length) {
        return null
    }

    const selectedOptions = Array.from(variantSelect.querySelectorAll("fieldset")).map(fieldset => {
        const select = fieldset.querySelector("select")

        if (select) {
            return select.value
        }

        const checkedInput = fieldset.querySelector("input:checked")
        return checkedInput ? checkedInput.value : null
    })

    return variantData.find(variant => {
        return !variant.options.map((option, index) => {
            return selectedOptions[index] === option
        }).includes(false)
    }) || null
}


function getImageGroupKey(img) {

    const altKey = normalizeText(img && img.alt)

    if (altKey) {
        return `alt:${altKey}`
    }

    const srcKey = normalizeText(img && img.src).replace(/[?&]v=\d+/g, "")

    return srcKey ? `src:${srcKey}` : ""
}


function getCurrentVariantGroupKey(data) {

    const currentVariant = getCurrentVariant()

    if (!currentVariant || !currentVariant.featured_media || !currentVariant.featured_media.id) {
        return ""
    }

    const featuredImage = data.find(img => String(img.id) === String(currentVariant.featured_media.id))

    return featuredImage ? getImageGroupKey(featuredImage) : ""
}


function normalizeMetal(metal) {

    metal = normalizeText(metal)

    const detectedMetal = detectMetal(metal)

    if (detectedMetal) {
        return detectedMetal
    }

    return metal
}


function getSelectedMetalMatches(metal) {

    const normalizedMetal = normalizeMetal(metal)

    switch (normalizedMetal) {
        case "platinum":
            return ["platinum", "white gold"]
        case "black gold":
            return ["black gold"]
        case "white gold":
            return ["white gold"]
        case "yellow gold":
            return ["yellow gold"]
        case "rose gold":
            return ["rose gold"]
        default:
            return normalizedMetal ? [normalizedMetal] : []
    }
}


function extractShape(value) {

    const text = normalizeText(value)

    if (text.includes("old mine") || text.includes("oldmine")) {
        return "old mine"
    }

    return knownShapes.find(shape => text.includes(shape)) || ""
}


function shapeMatches(imageShape, selectedShape) {

    if (!imageShape || !selectedShape) {
        return false
    }

    return normalizeText(imageShape).replace(/\s+/g, "") === normalizeText(selectedShape).replace(/\s+/g, "")
}


function metalMatches(imageMetal, selectedMetal) {

    if (!imageMetal || !selectedMetal) {
        return false
    }

    return getSelectedMetalMatches(selectedMetal).includes(normalizeMetal(imageMetal))
}


function parseAlt(alt, src) {

    const normalizedAlt = normalizeText(alt)
    const normalizedSrc = normalizeText(src)

    if (!normalizedAlt && !normalizedSrc) return { metal: "", shape: "" }

    const altParts = normalizedAlt ? normalizedAlt.split(" - ").map(part => part.trim()).filter(Boolean) : []
    const metal =
        altParts.map(part => detectMetal(part)).find(Boolean) ||
        detectMetal(normalizedAlt) ||
        detectMetal(normalizedSrc)

    if (!normalizedAlt) {
        return {
            metal: metal,
            shape: extractShape(normalizedSrc)
        }
    }

    if (altParts.length > 1) {
        return {
            metal: metal,
            shape: extractShape(altParts[1])
        }
    }

    return {
        metal: metal,
        shape: extractShape(normalizedAlt)
    }

}


function createImageVariantSlide(img, isInitialSlide) {

    const slide = document.createElement("div")
    const media = document.createElement("div")
    const zoomLink = document.createElement("a")
    const image = document.createElement("img")

    slide.className = "product-images__slide product-images__slide--image is-active"
    if (isInitialSlide) {
        slide.classList.add("is-initial-selected")
    }
    slide.id = "Slide-dynamic-" + img.id
    slide.setAttribute("data-media-id", img.id)

    media.className = "product-single__media product-single__media-image aspect-ratio aspect-ratio--adapt"
    media.id = "Media-Thumbnails-dynamic-" + img.id
    media.style.setProperty("--padding-bottom", "100%")

    zoomLink.href = img.zoomSrc || withShopifyImageWidth(img.src, 2048)
    zoomLink.className = "product-single__media-zoom"
    zoomLink.dataset.msrc = img.msrc || withShopifyImageWidth(img.src, 20)
    zoomLink.setAttribute("target", "_blank")
    zoomLink.setAttribute("tabindex", "-1")
    zoomLink.setAttribute("aria-label", "Zoom")
    if (img.alt) {
        zoomLink.setAttribute("title", img.alt)
    }
    zoomLink.innerHTML = zoomIconSvg

    if (img.width && img.height) {
        zoomLink.dataset.w = img.width
        zoomLink.dataset.h = img.height
        media.style.setProperty("--padding-bottom", `${(img.height / img.width) * 100}%`)
    }

    image.alt = img.alt || ""
    image.loading = "lazy"
    image.decoding = "async"

    image.onload = function () {

        if (image.naturalWidth && image.naturalHeight) {
            zoomLink.dataset.w = image.naturalWidth
            zoomLink.dataset.h = image.naturalHeight
            media.style.setProperty("--padding-bottom", `${(image.naturalHeight / image.naturalWidth) * 100}%`)
        }

    }

    image.src = img.src

    if (image.complete && image.naturalWidth && image.naturalHeight) {
        zoomLink.dataset.w = image.naturalWidth
        zoomLink.dataset.h = image.naturalHeight
        media.style.setProperty("--padding-bottom", `${(image.naturalHeight / image.naturalWidth) * 100}%`)
    }

    media.appendChild(zoomLink)
    media.appendChild(image)
    slide.appendChild(media)

    return slide

}


function createMarkupVariantSlide(mediaItem, isInitialSlide) {

    const template = document.createElement("template")
    template.innerHTML = (mediaItem.html || "").trim()

    const slide = template.content.firstElementChild

    if (!slide) {
        return createImageVariantSlide(mediaItem, isInitialSlide)
    }

    slide.classList.add("is-active")
    slide.classList.remove("is-initial-selected")

    if (isInitialSlide) {
        slide.classList.add("is-initial-selected")
    }

    slide.setAttribute("data-media-id", slide.getAttribute("data-media-id") || mediaItem.id)

    return slide

}


function createVariantSlide(mediaItem, isInitialSlide) {

    if (mediaItem && mediaItem.html) {
        return createMarkupVariantSlide(mediaItem, isInitialSlide)
    }

    return createImageVariantSlide(mediaItem, isInitialSlide)

}


function refreshSliderZoom(slider) {

    if (!slider) {
        return
    }

    slider.sliderItems = slider.querySelectorAll('[id^="Slide-"]')

    if (typeof slider.setupProductGallery === "function") {
        slider.setupProductGallery()
    }

    if (typeof slider.onPaginationResize === "function") {
        slider.onPaginationResize()
    }

}


function mediaMatchesCurrentSelection(mediaItem, metal, shape, currentVariantGroupKey) {

    const meta = parseAlt(mediaItem.alt, mediaItem.matchSrc || mediaItem.src)
    const imageGroupKey = getImageGroupKey(mediaItem)

    if (currentVariantGroupKey && imageGroupKey === currentVariantGroupKey) {
        return true
    }

    if (!metal && !shape) {
        return true
    }

    if (!meta.metal && !meta.shape) {
        return true
    }

    // if (metal && shape) {

    //     if (meta.metal && meta.shape) {
    //         return metalMatches(meta.metal, metal) && shapeMatches(meta.shape, shape)
    //     }

    //     if (meta.metal && !meta.shape) {
    //         return metalMatches(meta.metal, metal)
    //     }

    //     return false

    // }

if (metal && shape) {

    // exact metal + shape match
    if (meta.metal && meta.shape) {
        return metalMatches(meta.metal, metal) &&
               shapeMatches(meta.shape, shape)
    }

    // common shape image (Heart, Round etc)
    if (!meta.metal && meta.shape) {
        return shapeMatches(meta.shape, shape)
    }

    // metal-only image
    if (meta.metal && !meta.shape) {
        return metalMatches(meta.metal, metal)
    }

    return false
}    

    if (metal && !shape) {
        return meta.metal ? metalMatches(meta.metal, metal) : false
    }

    if (!metal && shape) {
        return meta.shape ? shapeMatches(meta.shape, shape) : false
    }

    return false

}


function isSlideVisibleWithinSlider(slide, slider) {

    if (!slide || !slider || slide.offsetParent === null) {
        return false
    }

    if (window.innerWidth > 1067) {
        return true
    }

    const slideRect = slide.getBoundingClientRect()
    const sliderRect = slider.getBoundingClientRect()
    const visibleWidth = Math.min(slideRect.right, sliderRect.right) - Math.max(slideRect.left, sliderRect.left)

    return visibleWidth > Math.min(slideRect.width * 0.35, 80)

}


function syncNativeVideoPlayback(slider) {

    if (!slider) {
        return
    }

    const slides = slider.querySelectorAll(".product-images__slide")

    slides.forEach(slide => {

        const video = slide.querySelector(".product-single__media-native-video video")

        if (!video) {
            return
        }

        const shouldPlay = isSlideVisibleWithinSlider(slide, slider)

        video.muted = true
        video.defaultMuted = true
        video.autoplay = true
        video.playsInline = true
        video.setAttribute("muted", "")
        video.setAttribute("autoplay", "")
        video.setAttribute("playsinline", "")
        video.setAttribute("webkit-playsinline", "")

        if (!video.getAttribute("preload")) {
            video.setAttribute("preload", "metadata")
        }

        if (shouldPlay) {
            const playPromise = video.play()

            if (playPromise && typeof playPromise.catch === "function") {
                playPromise.catch(function () { })
            }
        } else {
            video.pause()
        }

    })

}


function bindSliderMediaEvents(slider) {

    if (!slider || slider.dataset.variantMediaBound === "true") {
        return
    }

    slider.dataset.variantMediaBound = "true"

    slider.addEventListener("slideChanged", function () {
        syncNativeVideoPlayback(slider)
        updateSliderCounter(slider) // ✅ ADD THIS
    })

    slider.addEventListener("scroll", function () {
        window.clearTimeout(slider.variantVideoScrollTimer)
        slider.variantVideoScrollTimer = window.setTimeout(function () {
            syncNativeVideoPlayback(slider)
            updateSliderCounter(slider) // ✅ ADD THIS
        }, 120)
    }, { passive: true })
}

// function renderVariantImages() {

//     const data = getProductImages()

//     if (!data.length) return


//     const metalInput = document.querySelector('[name="Metal Type"]:checked')
//     const shapeInput = document.querySelector('[name="Shapes Can Be Set With"]:checked')

//     const metal = metalInput ? normalizeMetal(metalInput.value) : null
//     const shape = shapeInput ? normalizeText(shapeInput.value) : null
//     const currentVariantGroupKey = getCurrentVariantGroupKey(data)

//     const slider = document.getElementById("Product-Slider")

//     if (!slider) {
//         return
//     }

//     slider.innerHTML = ""

//     const matchedItems = data.filter(mediaItem => {
//         return mediaMatchesCurrentSelection(mediaItem, metal, shape, currentVariantGroupKey)
//     })

//     const itemsToRender = matchedItems.length ? matchedItems : data
//     const fragment = document.createDocumentFragment()

//     itemsToRender.forEach((mediaItem, index) => {
//         fragment.appendChild(createVariantSlide(mediaItem, index === 0))
//     })

//     if (itemsToRender.length) {
//         slider.appendChild(fragment)
//     }
//     bindSliderButtons(slider);
//     updateSliderCounter(slider)
//     refreshSliderZoom(slider)
//     window.requestAnimationFrame(function () {
//         syncNativeVideoPlayback(slider)
//     })

// }
let firstloadedimages = false;
function renderVariantImages() {
    const data = getProductImages()
    if (!data.length) return

    let slider = document.getElementById("Product-Slider")
    if (!slider){
        slider = document.querySelector(".product-quick-images");
        if (!slider){
            return;
        }
    } 

    const rtrSlide = slider.querySelector("#rtr-block-cont")?.closest(".product-images__slide")
    const metalInput = document.querySelector('[name="Metal Type"]:checked')
    const shapeInput = document.querySelector('[name="Shapes Can Be Set With"]:checked')

    const metal = metalInput ? normalizeMetal(metalInput.value) : null
    const shape = shapeInput ? normalizeText(shapeInput.value) : null
    const currentVariantGroupKey = getCurrentVariantGroupKey(data)

    const matchedItems = data.filter(mediaItem => {
        return mediaMatchesCurrentSelection(mediaItem, metal, shape, currentVariantGroupKey)
    })

    const itemsToRender = matchedItems.length ? matchedItems : data


    Array.from(slider.children).forEach(child => {
        if (child.id === "rtr-block-cont") return
        child.remove()

    })

    const fragment = document.createDocumentFragment()

    // ✅ Add only non-RTR images
    itemsToRender.forEach((mediaItem) => {

        // skip RTR item
        if (mediaItem.id === "rtr-custom" && firstloadedimages == true) return
            fragment.appendChild(createVariantSlide(mediaItem, false))
    })

    slider.appendChild(fragment)
    bindSliderButtons(slider)
    updateSliderCounter(slider)
    refreshSliderZoom(slider)

    window.requestAnimationFrame(function () {
        syncNativeVideoPlayback(slider)
    })
    firstloadedimages = true;

}


function updateSliderCounter(slider) {

    const slides = slider.querySelectorAll(".product-images__slide")
    const total = slides.length

    const totalEl = document.querySelector(".slider-counter--total")
    const currentEl = document.querySelector(".slider-counter--current")

    if (totalEl) totalEl.textContent = total

    if (currentEl) {
        const currentIndex = getActiveSlideIndex(slider)
        currentEl.textContent = total > 0 ? currentIndex : 0
    }
}


function waitForVariantInputs() {

    const slider = document.getElementById("Product-Slider")
    const jsonEl = document.getElementById("ProductVariantImages")

    if (!slider || !jsonEl) {
        return
    }

    const metalExists = document.querySelector('[name="Metal Type"]')
    const shapeExists = document.querySelector('[name="Shapes Can Be Set With"]')

    if (!metalExists && !shapeExists && waitForVariantInputsAttempts < 20) {

        waitForVariantInputsAttempts += 1

        setTimeout(waitForVariantInputs, 100)

        return
    }

    bindSliderMediaEvents(slider)
    renderVariantImages()

}


document.addEventListener("DOMContentLoaded", waitForVariantInputs)


document.addEventListener("change", function (e) {

    if (
        e.target.name === "Metal Type" ||
        e.target.name === "Shapes Can Be Set With"
    ) {

        renderVariantImages()

    }

})


document.addEventListener("product:variant-change", function () {

    renderVariantImages()

})


function getActiveSlideIndex(slider) {
    const slides = Array.from(slider.querySelectorAll(".product-images__slide"))

    for (let i = 0; i < slides.length; i++) {
        if (isSlideVisibleWithinSlider(slides[i], slider)) {
            return i + 1
        }
    }

    return 1
}

function bindSliderButtons(slider) {

    if (!slider) return

    const prevBtn = document.querySelector(".slider-button--prev")
    const nextBtn = document.querySelector(".slider-button--next")

    if (!prevBtn || !nextBtn) return

    const getSlideWidth = () => {
        const slide = slider.querySelector(".product-images__slide")
        return slide ? slide.offsetWidth : 0
    }

    prevBtn.onclick = function () {
        slider.scrollBy({
            left: -getSlideWidth(),
            behavior: "smooth"
        })
    }

    nextBtn.onclick = function () {
        slider.scrollBy({
            left: getSlideWidth(),
            behavior: "smooth"
        })
    }
}